import { useHistory } from "react-router-dom";
import AdminContentLayout from "../../layouts/AdminContentLayout";

function NotificationSettingsLayout({ children }: any): JSX.Element {
  const history = useHistory();
  return (
    <AdminContentLayout
      pageTitle="CSTL | Notification Settings"
      subHeaderTitle="Notification Settings"
      rightSectionClassName="overflow-hidden"
      redirect={() => history.push("/access/notifications")}
    >
      <div className="grid h-[calc(100vh_-_177px)] grid-rows-threeRowLayoutMobile md:grid-rows-none md:grid-cols-twoColumnSettingsTabletPageLayout lg:grid-cols-twoColumnSettingsPageLayout lg:h-[calc(100vh_-_120px)] ">
        {children}
      </div>
    </AdminContentLayout>
  );
}

export default NotificationSettingsLayout;
